import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { ComponentsModule } from '../../components/components.module';
import { ShiftPage } from './shift';

@NgModule({
  declarations: [ShiftPage],
  imports: [IonicPageModule.forChild(ShiftPage), ComponentsModule],
})
export class ShiftPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shift/shift.module.ts